import { admin } from "./admin";
import { agentApproval } from "./agentApproval";
import { app } from "./app";
import { calendar } from "./calendar";
import { chat } from "./chat";
import { common } from "./common";
import { demoPage } from "./demoPage";
import { featuresPage } from "./featuresPage";
import { genos } from "./genos";
import { history } from "./history";
import { inbox } from "./inbox";
import { integrations } from "./integrations";
import { layout } from "./layout";
import { noteAsk } from "./noteAsk";
import { notes } from "./notes";
import { services } from "./services";
import { settings } from "./settings";
import { sidebar } from "./sidebar";
import { spotlight } from "./spotlight";
import { tasks } from "./tasks";
import { threadAsk } from "./threadAsk";

export const en = {
    common,
    app,
    sidebar,
    layout,
    settings,
    chat,
    tasks,
    notes,
    inbox,
    integrations,
    spotlight,
    genos,
    threadAsk,
    noteAsk,
    services,
    admin,
    agentApproval,
    calendar,
    history,
    featuresPage,
    demoPage,
} as const;
